import UpdateIcon from '@mui/icons-material/Update';
import React from 'react';
import { useAlertUiTranslation } from '../../../hooks';
export function useAlertRefreshButton(handleRefresh) {
    const { t } = useAlertUiTranslation();
    return {
        label: t('common.refresh'),
        icon: React.createElement(UpdateIcon, null),
        onClick: handleRefresh,
    };
}
